import { render, staticRenderFns } from "./AllSubPage.vue?vue&type=template&id=a60e209c&scoped=true&"
import script from "./AllSubPage.vue?vue&type=script&lang=ts&"
export * from "./AllSubPage.vue?vue&type=script&lang=ts&"
import style0 from "./AllSubPage.vue?vue&type=style&index=0&id=a60e209c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60e209c",
  null
  
)

export default component.exports